export const ADD_NEWS = 'ADD_NEWS'
export const INITIAL_DETAIL_NEWS = 'INITIAL_DETAIL_NEWS'